import Vue from 'vue'
import Router from 'vue-router'
import UserPage from '../page/UserVote/UserVote.vue'
import SuccessLog from '../page/SuccessLogin/SuccessLogin.vue'
import SuccessNoLog from '../page/SuccessNoLogin/SuccessNoLogin.vue'


Vue.use(Router)

export default new Router({
  mode : 'history',
  routes: [
    {
      path: '/vote/entrance',
      name: 'UserPage',
      component: UserPage
    }, {
      path: '/vote/entrance/SuccessLog',
      name: 'SuccessLog',
      component: SuccessLog
    }, {
      path: '/vote/entrance/SuccessNoLog',
      name: 'SuccessNoLog',
      component: SuccessNoLog
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js